module.exports = __webpack_public_path__ + "assets/f9ef905bf8203e761a1a6a3b138695c8.mp3";